/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ZodiacPisces = [
  ["path", { d: "M19 21a15 15 0 0 1 0-18" }],
  ["path", { d: "M20 12H4" }],
  ["path", { d: "M5 3a15 15 0 0 1 0 18" }]
];

export { ZodiacPisces as default };
//# sourceMappingURL=zodiac-pisces.js.map
